<template>
  <div>
    <v-container fluid style="padding: 0 25px;">
      <v-card class="card2" style="margin-top: 10px">
        <v-card-text style="margin-top: -15px;">
          <div style="display: flex;justify-content: space-between;">
            <span style="font-weight: 500;font-size: 28px;"> {{ $t("modelList") }}</span>
            <div style="display: flex;">
              <div class="pa-2 search-panel" style="align-items: center;">
                <!-- Unified search input (Model ID or Name) -->
                <div class="custom-search-input-wrapper">
                  <div class="custom-search-input-container">
                    <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                    <input
                      id="search-keyword-gptmodelmanagement"
                      type="text"
                      :aria-label="$t('searchModelIdOrName')"
                      :placeholder="$t('searchModelIdOrName')"
                      class="custom-search-input"
                      v-model="searchKeyword"
                      @keydown.enter="Search"
                    />
                    <v-icon
                      class="clear-icon"
                      :style="searchKeyword ? '' : 'color: transparent !important;'"
                      @click="searchKeyword = ''"
                    >
                      mdi-close-circle
                    </v-icon>
                  </div>
                </div>

                <!-- Category filter dropdown (only show if categories exist) -->
                <div v-if="categories.length > 0" style="display: flex; align-items: center;">
                  <v-autocomplete
                    v-model="searchCategoryId"
                    :items="[{ id: null, name: $t('allCategories') }, ...dedupeCategories(categories)]"
                    item-title="name"
                    item-value="id"
                    density="compact"
                    variant="outlined"
                    :no-data-text="$t('noMatchingCategories')"
                    :menu-props="{ maxHeight: 320 }"
                    hide-details
                    style="min-width: 150px; font-size: 13px;"
                    @update:modelValue="Search"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="16" style="color: #1976D2; margin-right: 2px;">mdi-tag-outline</v-icon>
                    </template>
                  </v-autocomplete>
                </div>

                <!-- Add Category button (always visible) -->
                <v-btn
                  icon
                  variant="text"
                  density="comfortable"
                  size="small"
                  @click="openCategoryDialog"
                >
                  <v-icon size="20" color="#1976D2">mdi-tag-plus</v-icon>
                  <v-tooltip activator="parent" location="top">{{ $t("addCategory") }}</v-tooltip>
                </v-btn>
              </div>

              <div class="custom-vertical-divider"></div>

              <!-- ส่วนปุ่มการทำงาน -->
              <div style="display: flex;">
                <div class="action-controls">
                  <!-- Import Button -->
                  <v-btn
                    id="button-import-gptmodelmanagement"
                    color="#C32E0E"
                    class="control-btn import-btn"
                    variant="outlined"
                    size="large"
                    @click="triggerFileUpload"
                    rounded="lg"
                  >
                  <v-img :src="templateImg" alt="Template" class="template-icon"> </v-img>
                    {{ $t("import") }}
                    <v-tooltip activator="parent" location="top">
                      {{ $t("_importFileConfiguration") }}
                    </v-tooltip>
                  </v-btn>
                  
                  <!-- Create Button -->
                  <v-btn
                    id="button-create-gptmodelmanagement"
                    color="primary"
                    class="control-btn create-btn"
                    variant="flat"
                    size="small"
                    prepend-icon="mdi-plus"
                    @click="Add()"
                    rounded="lg"
                  >
                    {{ $t("create") }}
                    <v-tooltip activator="parent" location="top">
                      {{ $t("_createNewGptModel") }}
                    </v-tooltip>
                  </v-btn>
                </div>
                
                <!-- Hidden File Uploader -->
                <DragDropFile
                  ref="fileUploader"
                  :dialog="true"
                  :DragDrop="false"
                  :ShowListFile="false"
                  :NameButton="nameButton"
                  accept=".json"
                  @filesUploaded="processUpload($event)"
                  :allowType="['application/json']"
                  class="d-none"
                />
              </div>
            </div>
          </div>
        </v-card-text>
        <v-data-table-server
          v-model:options="options"
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          :items="menus"
          :headers="headers"
          :loading="loadingTable"
          style="padding: 0px 16px 0 16px;"
        >
          <template v-slot:item="{ item }">
            <tr>
              <!-- Model ID -->
              <td style="text-align: start; width: 70px;">
                <span style="font-size: 13px;">{{ item.modelDisplay }}</span>
              </td>

              <!-- Model Name + Status + Category -->
              <td style="max-width: 220px;">
                <div style="display: flex; align-items: center; gap: 6px;">
                  <span class="text-truncate-cell" style="font-size: 13px; max-width: 220px;">
                    {{ item.modelName }}
                    <v-tooltip v-if="item.modelName && item.modelName.length > 20" activator="parent" location="top">{{ item.modelName }}</v-tooltip>
                  </span>
                  <span
                    :style="{
                      width: '9px',
                      height: '9px',
                      borderRadius: '50%',
                      backgroundColor: item.isPublish ? '#4CAF50' : '#c1c3cb',
                      display: 'inline-block',
                      flexShrink: '0',
                      cursor: 'default'
                    }"
                  >
                    <v-tooltip activator="parent" location="top">
                      {{ item.isPublish ? $t('published') : $t('draft') }}
                    </v-tooltip>
                  </span>
                  <span v-if="item.categoryName" class="category-tag">
                    <v-icon size="13" style="margin-right: 3px;">mdi-tag-outline</v-icon>
                    <span class="text-truncate-cell" style="max-width: 80px;">{{ item.categoryName }}</span>
                    <v-tooltip v-if="item.categoryName && item.categoryName.length > 10" activator="parent" location="top">{{ item.categoryName }}</v-tooltip>
                  </span>
                </div>
              </td>

              <!-- Description -->
              <td style="text-align: start; max-width: 200px;">
                <span v-if="item.description" class="text-truncate-cell" style="font-size: 12px; color: #555; max-width: 200px; display: block;">
                  {{ item.description }}
                  <v-tooltip v-if="item.description.length > 30" activator="parent" location="top" max-width="300">{{ item.description }}</v-tooltip>
                </span>
                <span v-else style="color: #bbb; font-size: 12px;">—</span>
              </td>

              <!-- Action Menu -->
              <td style="width: 50px;">
                <v-menu location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-btn icon v-bind="props" variant="text" density="comfortable">
                      <v-icon id="icon-iconmenu-gptmodelmanagement" size="22">mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-list style="border-radius: 15px;">
                    <v-list-item :disabled="publishInFlight" @click="changePublishNow(item, true)">
                      <v-list-item-title id="list-publish-gptmodelmanagement">{{ $t("publish") }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="Replace(item.modelId, item.modelName)">
                      <v-list-item-title id="list-replace-gptmodelmanagement">{{ $t("gpt_model_management_replace") }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="Version(item.modelId, item.modelIDGroup)">
                      <v-list-item-title id="list-version-gptmodelmanagement">{{ $t("gpt_model_management_version_history") }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="Exportfileconfig(item.modelId)">
                      <v-list-item-title id="list-exportfileconfig-gptmodelmanagement">{{ $t("gpt_model_management_export_file_config") }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>

              <!-- Model (LLM Model Name) -->
              <td style="text-align: start; max-width: 160px;">
                <span class="text-truncate-cell" style="font-size: 13px; max-width: 160px; display: block;">
                  {{ item.model }}
                  <v-tooltip v-if="item.model && item.model.length > 22" activator="parent" location="top">{{ item.model }}</v-tooltip>
                </span>
              </td>

              <!-- Created By -->
              <td style="text-align: center; max-width: 120px;">
                <span class="text-truncate-cell" style="font-size: 13px; max-width: 120px; display: block; margin: 0 auto;">
                  {{ item.createBy }}
                  <v-tooltip v-if="item.createBy && item.createBy.length > 15" activator="parent" location="top">{{ item.createBy }}</v-tooltip>
                </span>
              </td>

              <!-- Actions -->
              <td style="text-align: center; width: 100px;">
                <div style="display: flex; justify-content: center; gap: 2px;">
                  <v-btn id="button-edit-uploadCSV" variant="text" density="comfortable" @click="Edit(item)" icon>
                    <img :src="images.edit" alt="Edit" style="width: 25px; height: 25px;" />
                    <v-tooltip activator="parent" location="top">{{ $t("edit") }}</v-tooltip>
                  </v-btn>
                  <v-btn
                    id="button-delete-uploadCSV"
                    variant="text"
                    density="comfortable"
                    @click="DeleteGroup(item)"
                    v-if="item.modelDisplay != 1"
                    icon
                    :disabled="btnDisableDelete(item)"
                  >
                    <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px;" />
                    <v-tooltip activator="parent" location="top">{{ $t("delete") }}</v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
          
          <!-- Table Footer with Total Results -->
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4 py-2"
              style="width: 100%"
            >
              <div>{{ $t("totalResults") }} {{ searchTotalTable }}</div>

              <v-data-table-footer
                :items-per-page-options="[10, 20, 50]"
                v-model:items-per-page="itemsPerPage"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <!-- Custom Delete Dialog -->
    <ConfirmDeleteDialog v-model="dialog_delete" :title="$t('delete')" @cancel="cancelDelete" @confirm="confirmDelete">
      <template v-slot:message>
        <span v-if="deleteItem">
          {{ $t("confirmDeleteModel", { no: deleteItem.modelDisplay }) }} "<strong>{{ deleteItem.modelName }}</strong>" ?
        </span>
      </template>
    </ConfirmDeleteDialog>

    <!-- Add Category Dialog -->
    <CategoryManageDialogs
      v-model:add-open="dialog_addCategory"
      v-model:rename-open="dialog_renameCategory"
      v-model:new-category-name="newCategoryName"
      v-model:rename-category-name="renameCategoryName"
      :category-name-options="categoryNameOptions"
      :filtered-categories="filteredCategoryDialogItems"
      @save="SaveCategory"
      @rename="RenameCategory"
      @delete="deleteCategory"
      @open-rename="openRenameCategoryDialog"
      @close-add="closeCategoryDialog"
      @close-rename="closeRenameCategoryDialog"
    />

    <!-- Dialog Replace -->
    <v-dialog v-model="dialog_replace" persistent max-width="600px">
      <v-card style="border-radius: 15px !important;">
        <v-card-title style="height: 56px;">
          <p class="headline" style="color: #1d4f81">
            {{ $t("gpt_model_management_replace") }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container>
          <div class="dialog-title-lable">
              <v-icon size="20" style="margin-right: 8px">mdi-swap-horizontal</v-icon>
                <span style="font-size: 16px;">{{ $t("replaceModel") }}</span>
          </div>
            <div style="margin-bottom: 2%">
              <span style="font-weight: 600;">{{ replace_modelName }}</span>
              <v-icon size="20">mdi-chevron-double-right</v-icon>
              <span style="color: #C32E0E; font-weight: bold">
                {{replace_modelName2}}
              </span>
            </div>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    id="model-autocomplete-popupreplace-gptmodelmanagement"
                    :label="$t('model') + '*'"
                    :rules="[rules.required]"
                    :items="replace_modelid_lists"
                    item-title="modelName"
                    item-value="modelIDGroup"
                    v-model="replace_modelid_list"
                    class="config-input"
                    clearable
                    outlined
                    required
                    variant="outlined"
                    density="comfortable"
                    hide-details="auto"
                    @update:modelValue="onModelChange"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- Outlined red Close button with left icon -->
          <v-btn
            class="replace-close-btn"
            variant="outlined"
            density="comfortable"
            @click="dialog_replace = false"
            style="margin-right: 15px;"
          >
            <v-icon left size="18">mdi-close</v-icon>
            {{$t("close")}}
          </v-btn>

          <!-- Gradient orange Save button with floppy icon -->
          <v-btn
            id="button-replacesave-popupreplace-gptmodelmanagement"
            class="replace-save-btn"
            variant="elevated"
            density="comfortable"
            @click="ReplaceSave"
          >
            <v-icon left size="18">mdi-floppy</v-icon>
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog Version -->
    <v-dialog v-model="dialog_version" max-width="800px">
      <v-card style="border-radius: 15px !important;">
        <v-card-title style="height: 56px;">
          <p class="headline" style="color: #1d4f81">
            {{ $t("gpt_model_management_version_history") }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container style="padding: 0;">
          <div class="dialog-title-lable">
              <v-icon size="20" style="margin-right: 8px">mdi-clock-time-three-outline</v-icon>
              <span style="font-size: 16px;">{{ $t("gpt_model_management_version_history") }}</span>
          </div>
            <v-data-table-server
              id="table-dialogversion-gptmodelmanagement"
              :items-per-page="options_version.itemsPerPage"
              :items-length="totalTable_version"
              v-model:options="options_version"
              :items="menus_version"
              :headers="headers_version_history"
              :items-per-page-options="[5, 10, 15]"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td style="text-align: start;">
                    <div style="display: flex;align-content: center;align-items: center;justify-content: flex-start;">
                      <div>{{ item.versioning }}</div>
                      <span
                        v-if="item.isPublish === true"
                        style="z-index: 1;">
                        <v-chip class="ml-3" size="small" label style="border-radius: 10px;background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%); color: #fff; font-weight: 500;">
                          {{ $t("latest")
                        }}</v-chip>
                      </span>
                    </div>
                  </td>
                  <td style="text-align: start"><span>{{ item.updateDate }}</span></td>
                  <td style="text-align: center">
                    <v-menu location="bottom">
                      <template v-slot:activator="{ props }">
                        <v-btn 
                        icon 
                        variant="text"
                        density="comfortable"
                        v-bind="props">
                          <v-icon
                            id="icon-iconmenu-popupversion-gptmodelmanagement"
                            size="22"
                            >mdi-dots-horizontal</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list style="border-radius: 15px;">
                        <!--Restore-->
                        <v-list-item
                          :key="item.modelId"
                          :disabled="publishInFlight"
                          @click="changeRestoreNewVersion(item)"
                        >
                          <v-list-item-title
                            id="list-restore-popupversion-gptmodelmanagement"
                            >{{ $t("restore") }}</v-list-item-title
                          >
                        </v-list-item>
                        <!--View-->
                        <v-list-item @click="view(item)">
                          <v-list-item-title
                            id="list-view-popupversion-gptmodelmanagement"
                            >{{ $t("view") }}</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                  <td style="text-align: start"><span>{{ item.updateBy }}</span></td>
                </tr>
              </template>
              <template v-slot:bottom>
                <div
                  class="d-flex justify-space-between align-center px-4 py-2"
                  style="width: 100%"
                >
                  <div>{{ $t("totalResults") }} {{ totalTable_version }}</div>

                  <v-data-table-footer
                    :items-per-page-options="[5, 10, 15]"
                    v-model:items-per-page="itemsPerPage"
                    :page="options.page"
                    :length="Math.ceil(totalTable_version / itemsPerPage)"
                  />
                </div>
              </template>
            </v-data-table-server>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="close-btn" @click="dialog_version = false">
            {{$t("close")}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--dialog version history view-->
    <v-dialog v-model="dialog_View">
      <v-card>
        <v-card-title>
          <p class="headline" style="color: #1d4f81">
            {{ $t("gpt_model_management_version_history_detail") }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <ModelManagement
              v-if="dialog_View"
              v-model="GPTModel"
              :editAction="null"
              :modelID="view_modelID"
              :GetDDModel="isParam"
              :page="isPage"
              :showValidationRuns="true"
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog_View = false">{{
            $t("close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Loading Please Wait... -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">{{ $t("_Loading") }}</h3>
          <p class="loading-subtitle">{{ $t("pleaseWait") }}</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>


<script>
import ModelManagement from "@/components/ModelManagement.vue";
import DragDropFile from "@/components/DragDropFile.vue";
import CategoryManageDialogs from "@/components/CategoryManageDialogs.vue";
import ConfirmDeleteDialog from "@/components/ConfirmDeleteDialog.vue";
import categoryOptionsMixin from "@/mixins/categoryOptionsMixin.js";
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import editImg from "@/assets/Icons/Edit.png";
import deleteImg from "@/assets/Icons/Delete.png";
import templateImg from "@/assets/Icons/user-import.svg";

// use i18n for internationalization
export default {
  name: "GPTModelManagement",
  inject: [
    "flagNav",
    "FontColorTitle",
    "SubNavbarBackGround",
    "Username",
    "RoleId"
  ],
  components: { ModelManagement, DragDropFile, CategoryManageDialogs, ConfirmDeleteDialog },
  mixins: [categoryOptionsMixin],
  
  data: () => ({
    loadingTable: false,
    checkbox1: false,
    EditdialogUser: false,
    Adddialog: false,
    dialog: false,
    dialog_delete: false,
    deleteItem: null,
    valid: true,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    maxLengthChar: 0,
    searchTotalTable: 0,
    totalTable: 0,
    loading: true,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    options_version: {
      page: 1,
      itemsPerPage: 5,
      sortBy: [],
      sortDesc: [],
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    DDVector: [],
    DDProvider: [
      "Azure",
      "Azure Postgresql",
      "Azure Internet",
      "Azure Internet",
      "Azure News",
    ],
    DDModel: [
      {
        provider: "Azure",
        model: "gpt-35-turbo-chat",
        maxPrompt: 4000,
      },
      {
        provider: "Azure",
        model: "gpt-35-turbo-16k",
        maxPrompt: 8000,
      },
      {
        provider: "Azure",
        model: "gpt-4",
        maxPrompt: 6000,
      },
      {
        provider: "Azure Postgresql",
        model: "gpt-35-postgresql",
        maxPrompt: 4000,
      },
      {
        provider: "Azure Postgresql",
        model: "gpt-35-16k-postgresql",
        maxPrompt: 8000,
      },
      {
        provider: "Azure Postgresql",
        model: "gpt-4-postgresql",
        maxPrompt: 6000,
      },
      {
        provider: "Azure Internet",
        model: "gpt-35-Internet",
        maxPrompt: 4000,
      },
      {
        provider: "Azure Internet",
        model: "gpt-35-16k-Internet",
        maxPrompt: 8000,
      },
      {
        provider: "Azure Internet",
        model: "gpt-4-Internet",
        maxPrompt: 6000,
      },
      {
        provider: "Azure News",
        model: "gpt-35-turbo-chat",
        maxPrompt: 4000,
      },
      {
        provider: "Azure News",
        model: "gpt-35-turbo-16k",
        maxPrompt: 8000,
      },
      {
        provider: "Azure News",
        model: "gpt-4",
        maxPrompt: 6000,
      },
    ],
    DDModelShow: [],
    DDGender: [
      {
        id: "m",
        name: "Male",
      },
      {
        id: "f",
        name: "Female",
      },
    ],

    searchKeyword: "",
    searchCategoryId: null,
    categories: [],
    dialog_addCategory: false,
    newCategoryName: "",
    dialog_renameCategory: false,
    renameCategoryName: "",
    renameCategoryTarget: null,
    isSearch: false,
    isFirst: true,
    menus: [],
    // flag เฉพาะของ publish/restore ไม่ใช้ dialog ที่เป็น overlay กลางร่วมกับทุกฟังก์ชัน
    // เพราะ Replace() เคลียร์ dialog ใน callback ของตัวเองได้ทั้งที่ไม่ได้เป็นคนตั้ง ทำให้ guard รั่ว
    publishInFlight: false,
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    GPTModel: {
      typeLLM: null,
      modelId: null,
      modelName: null,
      provider: null,
      model: null,
      APIVersion: null,
      extension: null,
      description: null,
      promptTemplate: "",
      gender: null,
      vectordbName: null,
      topVDB: null,
      internet: null,
      feedback: null,
      historyCount: null,
      historyMinute: null,
      temperature: null,
      topP: null,
      frequencyPenalty: null,
      presencePenalty: null,
      stop: null,
      maxTokens: null,
      isStream: false,
      versioning: null,
      isPublish: false,
      modelIDGroup: null,
      modelDisplay: null,
      DataIntegrationID: null,
      SqlModelID: null,
      promptSqlNoData: null,
      IntentGroupID: null,
      typingSpeed: null,
      isBypass: null,
      isAllowImage: null,
      isFeedback: null,
      groupReplaceID: null,
      productGroupID: null,
      cosine: null,
      isLongTerm_Memory: null,
      isChainMassage: null,
      lenChainMassage: null,
      len_ShortMemory: null,
      timeSecondChainMassage: null,
      maximumChatInput: null,
      monitorLineUserId: null,
      isShowNameUserMonitor: null,
      monitorSocialId: null,
      forbiddenWord: null,
      GuardRailModelID: null,
      enableTime: null,
      timeZone: null,
      jsonRequest: null,
      isAllowLLMChange: null,
      productTopVDB: null,
      productCosine: null,
      loadingBarFlag: null,
      loadingBarTime: null,
    },
    dialog_replace: false,
    dialog_View: false,
    replace_modelid: 0,
    replace_modelName: "",
    replace_modelName2: "",
    replace_modelid_list: { id: 0, name: "x" },
    replace_modelid_lists: [], //{id:0, name: "x"}
    dialog_version: false,
    menus_version: [],
    menus_modelid_version: 0,
    menus_modeliddisplay_version: 0,
    searchTotalTable_version: 0,
    totalTable_version: 0,
    sortBy: [],
    sortDesc: [],

    isParam: "getModel",
    isPage: "Model Creator",
    view_modelID: null,
    view_Model: {
      modelId: null,
      modelName: null,
      provider: null,
      model: null,
      APIVersion: null,
      extension: null,
      description: null,
      promptTemplate: "",
      gender: null,
      vectordbName: [],
      groupReplaceID: null,
      productGroupID: null,
      topVDB: null,
      internet: null,
      feedback: null,
      historyCount: null,
      historyMinute: null,
      temperature: null,
      topP: null,
      frequencyPenalty: null,
      presencePenalty: null,
      stop: null,
      maxTokens: null,
      isStream: false,
      isBypass: false,
      isFeedback: false,
      isAllowImage: false,
      versioning: null,
      isPublish: true,
      modelIDGroup: null,
      modelDisplay: null,
      Len_ShortMemory: null,
      IsLongTerm_Memory: false,
      IsChainMassage: null,
      LenChainMassage: null,
      TimeSecondChainMassage: null,
      Cosine: null,
      DataIntegrationID: null,
      SqlModelID: null,
      promptSqlNoData: null,
      IntentGroupID: null,
      maximumChatInput: 200000,
      enableTime: null,
      timeZone: null,
    },
    uploadedFiles: [],
    nameButton: "IMPORT FILE",
    entity: null,
    jsonData: {},
    templateImg: templateImg,
  }),
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    options_version: {
      handler() {
        if (this.menus_modelid_version != 0)
          this.Version(
            this.menus_modelid_version,
            this.menus_modeliddisplay_version
          );
      },
      deep: true,
    },
  },
  computed: {
    headers() {
      return [
        {
          title: this.$t("modelId"),
          value: "model_id",
          align: "start",
          sortable: false,
          width: "70px",
        },
        {
          title: this.$t("modelName"),
          value: "ModelName",
          align: "start",
          sortable: true,
          width: "220px",
        },
        {
          title: this.$t("description"),
          value: "Description",
          align: "start",
          sortable: false,
          width: "200px",
        },
        { title: " ", value: " ", align: "center", sortable: false, width: "50px" },
        {
          title: this.$t("model"),
          value: "ModelNameDisplay",
          align: "start",
          sortable: true,
          width: "160px",
        },
        {
          title: this.$t("createdBy"),
          value: "CreateBy",
          align: "center",
          sortable: true,
          width: "120px",
        },
        {
          title: this.$t("manage"),
          value: "Manage",
          align: "center",
          width: "100px",
          sortable: false,
        },
      ];
    },
    headers_version_history() {
      return [
        { title: this.$t("versionLabel"), align: "start", sortable: false, width: "150px" },
        { title: this.$t("modified"), align: "start", sortable: false },
        { title: " ", align: "center", sortable: false },
        { title: this.$t("modifiedBy"), align: "start", sortable: false },
      ];
    },
    categoryNameOptions() {
      return this.dedupeCategories(this.categories).map((category) => category.name);
    },
    filteredCategoryDialogItems() {
      const keyword = this.normalizeCategoryName(this.newCategoryName);
      const items = this.dedupeCategories(this.categories);

      if (!keyword) {
        return items;
      }

      return items.filter((category) => this.normalizeCategoryName(category.name).includes(keyword));
    },
  },
  methods: {
    findCategoryByName(name, excludeId = null) {
      const normalizedName = this.normalizeCategoryName(name);

      return this.dedupeCategories(this.categories).find((category) => {
        if (excludeId !== null && category.id === excludeId) {
          return false;
        }

        return this.normalizeCategoryName(category.name) === normalizedName;
      }) || null;
    },
    openCategoryDialog() {
      this.dialog_addCategory = true;
      this.closeRenameCategoryDialog();
      this.newCategoryName = "";
      this.GetCategories();
    },
    closeCategoryDialog() {
      this.dialog_addCategory = false;
      this.newCategoryName = "";
    },
    openRenameCategoryDialog(category) {
      this.renameCategoryTarget = category;
      this.renameCategoryName = category.name;
      this.dialog_renameCategory = true;
    },
    closeRenameCategoryDialog() {
      this.dialog_renameCategory = false;
      this.renameCategoryName = "";
      this.renameCategoryTarget = null;
    },
    updateCategoryListsAfterChange() {
      if (this.searchCategoryId && !this.categories.some((category) => category.id === this.searchCategoryId)) {
        this.searchCategoryId = null;
      }

      this.Get();
    },
    triggerFileUpload() {
      // เลือกวิธีใดวิธีหนึ่ง:
      // วิธีที่ 1: ถ้า DragDropFile มี method openFileDialog ที่ expose ออกมา
      if (this.$refs.fileUploader && typeof this.$refs.fileUploader.openFileDialog === 'function') {
        this.$refs.fileUploader.openFileDialog();
      } 
      // วิธีที่ 2: เข้าถึง input file ภายใน DragDropFile โดยตรง (ถ้าเป็นไปได้)
      else if (this.$refs.fileUploader && this.$refs.fileUploader.$el) {
        const fileInput = this.$refs.fileUploader.$el.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.click();
        }
      }
    },
    Refresh() {
      this.EditdialogUser = false;
    },
    Search() {
      this.dialog = true;
      this.isSearch = true;
      this.options.page = 1;
      this.GetDefault();
    },
    Get() {
      this.loadingTable = true;
      let { page, itemsPerPage, sortBy } = this.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
        modelName: this.searchKeyword,
        modelDisplayId: /^\d+$/.test((this.searchKeyword || '').trim()) ? Number.parseInt(this.searchKeyword) : null,
        categoryId: this.searchCategoryId || null,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      this.$call.GetTableGPTModel(
        temp,
        (dataResponse) => {
          this.loading = false;
          if (dataResponse.status == 0) {
            this.searchTotalTable = dataResponse.data.total;
            this.menus = dataResponse.data.data;
            this.totalTable = this.isFirst
              ? dataResponse.data.total
              : this.totalTable;
          } else {
            this.menus = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          this.loadingTable = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          this.loadingTable = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDefault() {
      this.dialog = true;
      const { itemsPerPage } = this.options;
      let temp = {
        page: 1,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
        modelName: this.searchKeyword,
        modelDisplayId: /^\d+$/.test((this.searchKeyword || '').trim()) ? Number.parseInt(this.searchKeyword) : null,
        categoryId: this.searchCategoryId || null,
        sortDesc: null,
        sortBy: null,
      };
      this.$call.GetTableGPTModel(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.searchTotalTable = dataResponse.data.total;
            this.menus = dataResponse.data.data;
            this.totalTable = this.isFirst
              ? dataResponse.data.total
              : this.totalTable;
          } else {
            this.menus = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          this.dialog = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    DeleteGroup(item) {
      this.deleteItem = item;
      this.dialog_delete = true;
    },
    confirmDelete() {
      if (!this.deleteItem) return;
      
      try {
        this.dialog_delete = false;
        this.dialog = true;
        
        this.$call.DeleteGPTModel(
          this.deleteItem.modelId,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = "✔ " + dataResponse.message;
              this.showSuccessBanner(msgSuccess);
              this.EditdialogUser = false;
              this.Get();
            } else if (dataResponse.status == 1) {
              this.$swal.fire({
                icon: "error",
                title: dataResponse.message,
                showConfirmButton: true,
                confirmButtonText: this.$t("gotIt"),
                confirmButtonColor: "#d33",
              });
            }
            this.dialog = false;
            this.deleteItem = null;
          },
          (errorResource) => {
            this.dialog = false;
            this.Adddialog = false;
            this.deleteItem = null;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
        this.deleteItem = null;
      }
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    Add() {
      this.$router.push({
        name: "GPTModelDetail",
        query: {
          id: null,
        },
      });
    },
    Edit(item) {
      this.$router.push({
        name: "GPTModelDetail",
        query: {
          id: item.modelId,
        },
      });
    },
    Clear() {
      this.EditdialogUser = false;
      this.Adddialog = false;
    },
    validatePrompt(inputValue) {
      if (!inputValue) {
        return true;
      }
      return (
        inputValue.length <= this.maxLengthChar ||
        "ฝรุณาฝรอฝข้อมูลตัวอัฝษรไม่เฝิน " +
          this.convertNumberToStringFormat(this.maxLengthChar)
      );
    },
    validateInput0_1(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำ๝หน่ง
      const value = Number.parseFloat(inputValue);
      if (Number.isNaN(value)) return "required.";
      return (
        (value >= 0 && value <= 1 && this.isTwoDecimalPlaces(value)) ||
        "ฝรุณาป้อนตัวเลขระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำ๝หน่ง"
      );
    },
    validateInput0_2(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำ๝หน่ง
      const value = Number.parseFloat(inputValue);
      if (Number.isNaN(value)) return true;
      return (
        (value >= 0 && value <= 2 && this.isTwoDecimalPlaces(value)) ||
        "ฝรุณาป้อนตัวเลขระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำ๝หน่ง"
      );
    },
    convertNumberToStringFormat(value) {
      const [intPart, decPart] = value.toString().split('.');
      const grouped = intPart.split('').reverse().join('').replace(/(\d{3})(?=\d)/g, "$1,").split('').reverse().join('');
      return decPart !== undefined ? `${grouped}.${decPart}` : grouped;
    },
    changeProvider(value) {
      if (value == null || value == "") {
        this.DDModelShow = this.DDModel;
        return "required.";
      }
      let ddm = this.DDModel.filter((e) => e.provider == value);
      if (ddm.length == 0) {
        this.DDModelShow = this.DDModel;
      } else {
        this.DDModelShow = this.DDModel.filter((e) => e.provider == value);
      }
    },
    changeModel(value) {
      if (value == null || value == "") {
        this.maxLengthChar = 0;
        return "required.";
      }
      let ddm = this.DDModel.find((e) => e.model == value);
      if (ddm) {
        this.maxLengthChar = this.DDModel.find(
          (e) => e.model == value
        ).maxPrompt;
      }
    },
    changePublishNow(item, is_publish) {
      // Publish/Restore หนึ่งครั้งคือการ insert เวอร์ชันใหม่หนึ่งแถว สองคำขอที่ซ้อนกันเคยทำให้เกิด
      // สองแถวที่ publish พร้อมกันในกลุ่มเดียวจนลิสต์โชว์ Model ID ซ้ำ
      // guard ด้วย predicate เดียวกับ :disabled ของ v-list-item ตาม convention ในโปรเจกต์
      if (this.publishInFlight) return;
      this.publishInFlight = true;
      this.dialog = true;
      if (item.isPublish == true && is_publish == true) { //NOSONAR
        this.publishInFlight = false;
        this.dialog = false;
        this.$swal.fire({
          icon: "info",
          title: this.$t("alreadyPublishedModel"),
          showConfirmButton: true,
          confirmButtonText: this.$t("gotIt"),
          confirmButtonColor: "#4BB543",
        });
        return;
      }
      this.$call.PublishGPTModel(
        item.modelId,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            let msgSuccess = "✔ " +
                this.$t("publish") +
                " " +
                item.modelName +
                " " +
                this.$t("success");
            this.showSuccessBanner(msgSuccess, 2500);
            this.Get();
          }
          this.publishInFlight = false;
          this.dialog = false;
          return null;
        },
        (errorResource) => {
          this.publishInFlight = false;
          this.dialog = false;
          this.isSearch = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    changeRestoreNewVersion(item) {
      if (this.publishInFlight) return;
      this.publishInFlight = true;
      this.dialog = true;
      this.$call.PublishGPTModel(
        item.modelId,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            let msgSuccess = "✔ " +
                this.$t("restoreVersion") +
                " " +
                item.modelName +
                " " +
                this.$t("success");
            this.showSuccessBanner(msgSuccess, 2500);
            this.Get();
          }else if (dataResponse.status == 2) {
            this.$router.push({
              name: "GPTModelDetail",
              query: {
                id: item.modelId,
              },
            });
          }
          this.publishInFlight = false;
          this.dialog = false;
          this.dialog_version = false;
          return null;
        },
        (errorResource) => {
          this.publishInFlight = false;
          this.dialog = false;
          this.isSearch = false;
          this.dialog_version = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    async Save() {
      this.dialog = true;
      try {
        const onSuccess = async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.$swal.fire({
              icon: "success",
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.Get();
          }
          this.dialog = false;
        };
        const onError = (errorResource) => {
          this.dialog = false;
          this.Adddialog = false;
          console.error(errorResource);
        };
        await this.$call[this.GPTModel.modelId == null ? "AddGPTModel" : "UpdateGPTModel"](this.GPTModel, onSuccess, onError);
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    showSuccessBanner(title, timer = 1500) {
      this.$swal.fire({
        title,
        showConfirmButton: false,
        timer,
        position: 'top',
        background: 'transparent',
        customClass: {
          popup: 'success-banner',
          title: 'success-banner-title'
        },
      });
    },
    async Replace(modelid, modelName) {
      this.dialog_replace = true;
      this.replace_modelid = modelid;
      this.replace_modelName = modelName;
      this.replace_modelName2 = "";
      this.replace_modelid_list = [];

      let raw = { page: 1, perPage: this.totalTable };
      this.$call.GetTableGPTModel(
        raw,
        (result) => {
          this.replace_modelid_list = [];
          if (result.status == 0) {
            let model = result.data.data.find((o) => o.modelId == modelid);

            if (model.isPublish == true) { //NOSONAR
              let models = result.data.data.filter(
                (o) => o.modelId != modelid && o.isPublish == true //NOSONAR
              );
              this.replace_modelid_lists = models;
            } else {
              let models = result.data.data.filter((o) => o.modelId != modelid);
              this.replace_modelid_lists = models;
            }
          }
          this.dialog = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (error) => {
          this.dialog = false;
          this.isSearch = false;
          alert(error);
        }
      );
    },
    async ReplaceSave() {
      this.dialog = true;

      if (this.replace_modelid_list == undefined) {
        this.dialog = false;
        return;
      }

      let model_id = this.replace_modelid;
      let GPTModel_model_id = this.replace_modelid_lists.find(
        (o) => o.modelIDGroup == this.replace_modelid_list
      ).modelId;
      this.$call.ReplaceGPTModel(
        {
          source: model_id,
          destination: GPTModel_model_id,
        },
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if (dataResponse.status == 0) {
              let msgSuccess ="✔ Successfully Replaced!";
              this.showSuccessBanner(msgSuccess);
              this.Get();
            }
          }
          this.dialog_replace = false;
          this.dialog = false;
          return null;
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          this.dialog_replace = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    async ReplaceChange(value) {
      this.replace_modelid = value;
    },
    view(val) {
      this.view_modelID = val.modelId;
      this.isPage = "view model";
      this.dialog_View = true;
    },
    async Version(modelId, modelIDGroup) {
      this.dialog = true;
      if (!this.dialog_version) {
        this.options_version.page = 1;
        this.options_version.itemsPerPage = 5;
      }

      this.dialog_version = true;
      this.menus_modelid_version = modelId;
      this.menus_modeliddisplay_version = modelIDGroup;

      const { page, itemsPerPage } = this.options_version;
      let temp = {
        page: page == undefined ? 1 : page,
        perPage: itemsPerPage,
        modelId: modelId,
        modelIDGroup: modelIDGroup,
      };

      this.$call.GetTableGPTModelVersioning(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if (
              dataResponse.data.total == 1 &&
              dataResponse.data.data[0].isPublish == false //NOSONAR
            ) {
              this.menus_version = [];
            } else {
              this.menus_version = dataResponse.data.data;
            }
            this.searchTotalTable_version = dataResponse.data.total;
            this.totalTable_version = dataResponse.data.total;
          } else {
            this.menus_version = [];
            this.searchTotalTable_version = 0;
            this.totalTable_version = 0;
          }
          this.dialog = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Exportfileconfig(id) {
      let req = {
        modelID: id,
      };
      this.dialog = true;
      this.$call.ExportFileConfigModel(
        req,
        (dataResponse) => {
          this.dialog = false;
          if (dataResponse) {
            // สร้าง FileReader เพื่ออ่าน Blob
            const reader = new FileReader();

            // เมื่อ FileReader โหลดเสร็จ
            reader.onload = () => {
              try {
                // ๝ปลงผลลัพธ์จาฝ FileReader เป็น JSON
                const jsonResponse = JSON.parse(reader.result);
                //ทำฝารจัดฝารไฟล์
                let fileURL = globalThis.URL.createObjectURL(
                  new Blob([JSON.stringify(jsonResponse, null, 2)])
                );
                let fileLink = document.createElement("a");

                fileLink.href = fileURL;
                let fileName = `ExportFileConfigModel_${this.convertDateToString(
                  new Date(),
                  ""
                )}.json`;
                fileLink.setAttribute("download", fileName);
                document.body.appendChild(fileLink);

                fileLink.click();
              } catch (error) {
                console.error("Error parsing JSON:", error);
              }
            };

            // เริ่มอ่าน Blob เป็นข้อความ
            reader.readAsText(new Blob([dataResponse])); //NOSONAR
          }
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    convertDateToString(date, seperator = "-") {
      return dateUtils.getStringWithTimeFromDate2(
        moment(date).toDate(),
        seperator
      );
    },
    processUpload(event) {
      this.files = event;
      const reader = new FileReader();
      const file = this.files[0];
      reader.onload = (e) => {
        try {
          this.jsonData = JSON.parse(e.target.result); // ๝ปลง JSON ที่อัปโหลดได้
          this.ValidateFile(this.files);
          this.ImportFileModelConfig();
        } catch (error) { //NOSONAR
          // error intentionally not rethrown
          console.error("Invalid JSON file");
        }
      };
      reader.readAsText(file); //NOSONAR
    },
    ValidateFile(files) {
      const formDataDoc = new FormData();
      formDataDoc.append("import_file", files[0]);
      this.uploadedFiles = files;
      this.entity = formDataDoc;
    },
    ImportFileModelConfig() {
      this.dialog = true;
      this.$call.ImportFileModelConfig(
        this.jsonData,
        (dataResponse) => {
          this.dialog = false;
          if (dataResponse.status == 0) {
            let msgSuccess = "✔ " + dataResponse.message;
            this.showSuccessBanner(msgSuccess);
            this.totalTable = this.totalTable + 1;
            this.Get();
          }
        },
        (errorResource) => {
          this.dialog = false;
          this.Adddialog = false;
          console.error(errorResource);
        }
      );
    },

    onModelChange(value) {
      this.replace_modelName2 = this.replace_modelid_lists.find(e => e.modelIDGroup == value)?.modelName || '';
    },

    GetCategories() {
      try {
        if (typeof this.$call.GetGPTModelCategory !== 'function') {
          this.categories = [];
          return;
        }
        this.$call.GetGPTModelCategory(
          (dataResponse) => {
            if (dataResponse && dataResponse.status == 0) {
              this.categories = this.dedupeCategories(dataResponse.data || []);
            } else {
              this.categories = [];
            }
          },
          () => { this.categories = []; }
        );
      } catch (e) { //NOSONAR
        // error intentionally not rethrown
        this.categories = [];
      }
    },
    SaveCategory() {
      if (!this.normalizeCategoryDisplayName(this.newCategoryName)) {
        this.$swal.fire({
          icon: "warning",
          title: this.$t("categoryNameRequired"),
          showConfirmButton: true,
          confirmButtonText: this.$t("ok"),
          confirmButtonColor: "#FFA726",
        });
        return;
      }
      const name = this.normalizeCategoryDisplayName(this.newCategoryName);
      const duplicateCategory = this.findCategoryByName(name);
      const isDuplicate = !!duplicateCategory;
      if (isDuplicate) {
        this.$swal.fire({
          icon: "warning",
          title: this.$t("categoryAlreadyExists", { name }),
          showConfirmButton: true,
          confirmButtonText: this.$t("ok"),
          confirmButtonColor: "#FFA726",
        });
        return;
      }
      try {
        if (typeof this.$call.AddGPTModelCategory !== 'function') {
          return;
        }
        this.$call.AddGPTModelCategory(
          { name },
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = "✔ " + this.$t("categoryCreatedSuccess", { name });
              this.showSuccessBanner(msgSuccess);
              this.newCategoryName = "";
              this.GetCategories();
            } else if (dataResponse.status == 1) {
              this.$swal.fire({
                icon: "warning",
                title: dataResponse.message || this.$t("duplicateCategoryName"),
                showConfirmButton: true,
                confirmButtonText: this.$t("ok"),
                confirmButtonColor: "#FFA726",
              });
            }
          },
          (error) => { console.error(error); }
        );
      } catch (e) {
        console.error('AddGPTModelCategory error:', e);
      }
    },
    RenameCategory() {
      if (!this.renameCategoryTarget?.id) {
        return;
      }

      if (!this.normalizeCategoryDisplayName(this.renameCategoryName)) {
        this.$swal.fire({
          icon: "warning",
          title: this.$t("categoryNameRequired"),
          showConfirmButton: true,
          confirmButtonText: this.$t("ok"),
          confirmButtonColor: "#FFA726",
        });
        return;
      }

      const name = this.normalizeCategoryDisplayName(this.renameCategoryName);
      const duplicateCategory = this.findCategoryByName(name, this.renameCategoryTarget.id);
      if (duplicateCategory) {
        this.$swal.fire({
          icon: "warning",
          title: this.$t("categoryAlreadyExists", { name }),
          showConfirmButton: true,
          confirmButtonText: this.$t("ok"),
          confirmButtonColor: "#FFA726",
        });
        return;
      }

      this.$call.UpdateGPTModelCategory(
        { id: this.renameCategoryTarget.id, name },
        (dataResponse) => {
          if (dataResponse.status == 0) {
            const selectedCategoryId = this.searchCategoryId;
            this.showSuccessBanner("✔ " + this.$t("categoryRenamedSuccess", { name }));
            this.closeRenameCategoryDialog();
            this.GetCategories();
            this.updateCategoryListsAfterChange();
            this.searchCategoryId = selectedCategoryId;
            return;
          }

          this.$swal.fire({
            icon: "warning",
            title: dataResponse.message || this.$t("duplicateCategoryName"),
            showConfirmButton: true,
            confirmButtonText: this.$t("ok"),
            confirmButtonColor: "#FFA726",
          });
        },
        (error) => { console.error(error); }
      );
    },
    deleteCategory(category) {
      this.$swal.fire({
        icon: "warning",
        title: this.$t("_deleteCategoryConfirm", { name: category.name }),
        text: this.$t("_deleteCategoryWarning"),
        showCancelButton: true,
        confirmButtonText: this.$t("delete"),
        cancelButtonText: this.$t("cancel"),
        confirmButtonColor: "#d33",
      }).then((result) => {
        if (!result.isConfirmed) {
          return;
        }

        this.$call.DeleteGPTModelCategory(
          category.id,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.showSuccessBanner("✔ " + this.$t("categoryDeletedSuccess", { name: category.name }));
              if (this.searchCategoryId === category.id) {
                this.searchCategoryId = null;
              }
              if (this.renameCategoryTarget?.id === category.id) {
                this.closeRenameCategoryDialog();
              }
              this.GetCategories();
              this.updateCategoryListsAfterChange();
              return;
            }

            this.$swal.fire({
              icon: "warning",
              title: dataResponse.message || this.$t("unableToDeleteCategory"),
              showConfirmButton: true,
              confirmButtonText: this.$t("ok"),
              confirmButtonColor: "#FFA726",
            });
          },
          (error) => { console.error(error); }
        );
      });
    },
    btnDisableDelete(item) {
      return (this.RoleId == 2 || this.RoleId == 6) && item.createBy != this.Username;
    }
  },
  mounted() {
    this.GetDate();
    this.GetCategories();
  },
};
</script>

<style scoped>
.replace-close-btn {
  border: 1px solid #C32E0E !important; /* red outline */
  color: #C32E0E !important;
  background: transparent !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  height: 40px !important;
  width: 100px !important;
}
.replace-close-btn .v-icon {
  margin-right: 6px;
}
.replace-save-btn {
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%) !important; /* orange gradient */
  color: #fff !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  height: 40px !important;
  width: 120px !important;
  box-shadow: 0 4px 10px rgba(195,46,14,0.25) !important;
}
.replace-save-btn .v-icon {
  margin-right: 6px;
}
</style>
<style scoped>
.card2 {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: none !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.card {
  border-radius: 16px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

/* ปรับแต่ง responsive */
@media (max-width: 600px) {
  .justify-end {
    justify-content: flex-start;
  }
}

/* Custom Vertical Divider */
.custom-vertical-divider {
  width: 1px;
  height: 40px;
  background: rgba(0, 0, 0, 0.1);
  margin: 0 16px;
  align-self: center;
  border-radius: 1px;
}

/* Action Controls */
.action-controls {
  display: flex;
  align-items: center;
  background: transparent;
  padding: 4px 8px;
  border: none;
  transition: all 0.2s ease;
  gap: 16px;
}

/* Control Buttons */
.control-btn {
  font-weight: 500;
  letter-spacing: 0.025em;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.import-btn {
  border-radius: 12px !important;
  width: 120px;
  height: 40px;
  color: #C32E0E !important;
  font-size: 13px !important;
  background-color: transparent !important;
  border: 1px solid #C32E0E !important;
}

.create-btn {
  width: 120px;
  box-shadow: 0 1px 3px rgba(25, 118, 210, 0.2);
  border-radius: 12px !important;
  margin: 0 !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .action-controls {
    width: 100%;
    justify-content: space-between;
    min-width: auto;
  }
  
  .control-btn {
    flex: 1;
    margin: 0 2px;
  }
}
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 14px;
  align-self: center;
  border-radius: 1px;
}

/* Table improvements */
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

/* Body rows - ไม่มี border, สะอาด */
:deep(.v-data-table tbody tr:hover) {
  background-color: #F8F9FA !important;
}

:deep(.v-data-table .v-table__wrapper > table > tbody > tr > td) {
  border: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr > th) {
  border: none !important;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-start .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}

/* Search panel improvements */
.search-panel {
  gap: 16px;
}

/* Header improvements */
:deep(.v-toolbar) {
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
}

/* Smooth animations */
* {
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, 
              transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

/* Loading states */
.v-skeleton-loader {
  border-radius: 12px !important;
}

/* Focus states */
.control-btn:focus-visible {
  outline: 2px solid rgb(25, 118, 210);
  outline-offset: 2px;
}

/* Custom scrollbar */
:deep(.v-data-table__wrapper)::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-track {
  background: transparent;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.headline {
  font-weight: 600 !important;
  font-size: 26px !important;
  color: #171717 !important;
  margin: 10px 0 0 15px;
}
.dialog-title-lable{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  margin: 0 -50px 10px -50px;
}
:deep(thead) {
  background-color: #FFE4E1 !important;
}
.close-btn {
  border: 1px solid #C32E0E !important; /* red outline */
  color: #C32E0E !important;
  background: transparent !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  height: 40px !important;
  width: 100px !important;
}

/* Dropdown items per page */
:deep(.v-data-table-footer .v-field) {
  border-radius: 10px !important;
  width: 70px !important;
}
:deep(.v-data-table-footer .v-select) {
  width: 80px !important;
}

.config-input {
    margin-bottom: 0px;
}

.config-input :deep(.v-field) {
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
}

.config-input :deep(.v-field:hover) {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}
.template-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

/* Category tag badge */
.category-tag {
  display: inline-flex;
  align-items: center;
  background: #EBF3FF;
  color: #1565C0;
  border: 1px solid #BBDEFB;
  border-radius: 20px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  max-width: 130px;
}

/* Text truncation utility */
.text-truncate-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
